import { Spin } from "antd";
import React, { useState } from "react";

import CDDForm from "@/components/Pledge/CDDForm";
import Breadcrumbs from "@/components/common/Breadcrumb";
import styles from "@/pages/DueDiligence/DueDiligence.module.css";

const DueDiligence: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <div className={styles.container}>
      <Spin spinning={loading} fullscreen />
      <div className={styles.customBreadCrumbs}>
        <Breadcrumbs items={[{ label: "Due Diligence" }]} />
      </div>
      <div className={styles.mainContainer}>
        <CDDForm setLoading={setLoading} />
      </div>
    </div>
  );
};

export default DueDiligence;
